import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { TabPanel } from 'devextreme-react/tab-panel';
import { PublicCompetitionEvents, PublicCompetitionCombinedEvents, PublicCompetitionClubs, PublicCompetitionScoreboard } from '../../components';

export default function CompetitionPage() {
    const {
        competitionName,
        section,
        setting1,
        setting2,
        setting3,
        setting4
    } = useParams();

    // Tab-Index basierend auf section-Parameter setzen
    const getInitialTabIndex = () => {
        switch(section) {
            case 'events': return 0;
            case 'comibined-events': return 1;
            case 'clubs': return 2;
            case 'scoreboard': return 3;
            default: return 0;
        }
    };

    const [selectedTabIndex, setSelectedTabIndex] = useState(getInitialTabIndex());

    const tabsData = [
        {
            title: 'Wettkämpfe',
            component: <PublicCompetitionEvents competitionName={competitionName} session={setting1} event={setting2} />
        },
        {
            title: 'Mehrkämpfe',
            component: <PublicCompetitionCombinedEvents competitionName={competitionName} combinedEvent={setting1} />
        },
        {
            title: 'Vereine',
            component: <PublicCompetitionClubs competitionName={competitionName} club={setting1} athlete={setting2} />
        },
        {
            title: 'Scoreboard',
            component: <PublicCompetitionScoreboard competitionName={competitionName} />
        }
    ];

    const handleTabSelectionChanged = (e) => {
        setSelectedTabIndex(e.selectedIndex);
    };

    return (
        <React.Fragment>
            <div style={{ padding: '20px' }}>                
                <TabPanel
                    dataSource={tabsData}
                    selectedIndex={selectedTabIndex}
                    onSelectionChanged={handleTabSelectionChanged}
                    height="auto"
                    showNavButtons={true}
                    scrollByContent={true}
                    scrollingEnabled={true}
                    itemTitleRender={(item) => item.title}
                    itemRender={(item) => (
                        <div style={{ padding: '20px 0' }}>
                            {item.component}
                        </div>
                    )}
                />
            </div>
        </React.Fragment>
    );
}
